import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "left" }

import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { useRouter } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'CardTitle',
  props: {
    title: {},
    path: {}
  },
  emits: ["jump"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "86fbd094": (_unref(themeColor)),
  "274cf122": (_unref(themeColorWithAlpha))
}))

const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.1)
const router = useRouter()
const props = __props
const emit = __emit
const handleClick = () => {
  router.push(props.path)
  emit('jump')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "dot" }, null, -1)),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", {
      class: "right",
      onClick: handleClick
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('app_more')), 1),
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "iconfont icon-icon_shouye_tiaozhuan" }, null, -1))
    ])
  ]))
}
}

})